<template>
  <div class="order_list">

    <template v-if="list.length !=0">
      <ul class="list_ul">
        <mu-load-more :loaded-all="loadall" :loading="loading" @load="load">

          <li class="list_ul_li" @click="link_makeDeta(item.orderNo)" v-for="item in list" :key="item.id" >
            <div class="list_name">
<!--              <p class="exa">{{ item.productCategory }}</p>-->
              <p v-if="item.productCategory == 0" class="exa">体检套餐</p>
              <p v-if="item.productCategory == 1" class="stomach">胃肠镜筛查</p>
              <p v-if="item.productCategory == 2" class="exa">整合式筛查</p>
              <p v-if="item.productCategory == 3" class="stomach">锦医未</p>
              <p v-if="item.orderStatus == 1" class="to-be-served">待服务</p>
            </div>
            <div class="list_li_deta">
              <img :src="item.thumbnail" alt="">
              <div class="list_item">
                <h2>{{ item.productName }}</h2>
                <p class="list_item_p1">{{ item.subhead }}</p>
<!--                <p class="list_item_p2">¥ {{ item.productPrice }}</p>-->
                <p class="list_item_p2">{{ item.actualPaymentAmount != 0 ? "¥" + item.actualPaymentAmount : "卡支付" }}</p>
              </div>
            </div>
            <ul class="list_ul_name">
              <li>
                <span>就诊人</span>
                <p>{{ item.name }}</p>
              </li>

<!--              <template v-if="item.productType == 1">-->
<!--                <li class="list_ul_name_list" v-for="items in item.appointments" :key="items.id">-->
<!--                  <h2>{{ items.productName }}</h2>-->
<!--                  <div class="time">-->
<!--                    <div class="list_ul_name_list_time">-->
<!--                      <span>预约时间</span>-->
<!--                      <p>{{ items.appointmentDate }} {{ items.appointmentTime }}</p>-->
<!--                    </div>-->
<!--                    <div class="list_ul_name_list_time">-->
<!--                      <span>预约地点</span>-->
<!--                      <p>{{ items.hospitalName }}（{{ items.address }}）</p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--              </template>-->

<!--              <template v-if="item.productType == 0">-->
<!--                <li>-->
<!--                  <span>预约时间</span>-->
<!--                  <p>{{ item.appointments[0].appointmentDate }} {{ item.appointments[0].appointmentTime }}</p>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <span>预约地点</span>-->
<!--                  <p>{{ item.appointments[0].hospitalName }}（{{ item.appointments[0].address }}）</p>-->
<!--                </li>-->
<!--              </template>-->
            </ul>
          </li>

        </mu-load-more>
      </ul>
    </template>

    <template v-else>
      <NoList>
        <template #text>
          <p>您还没有预约记录</p>
        </template>
      </NoList>
    </template>

  </div>
</template>

<script>
export default {
  name: "MyMake",
  data() {
    return{
      loading: false,
      loadall: false,
      list: [],
      list_json: {
        pageNum: 1,
        pageSize: 10,
      }
    }
  },
  created() {
    this.$isIos();

    // 获取我的预约列表
    this.get_list(this.list_json);
  },
  mounted() {

  },
  methods: {
    // 获取我的预约列表
    get_list(y) {
      this.$get("appointment",y)
        .then(res=> {
          if(res) {

            console.log(res.data.list);

            this.loadall= !res.data.hasNextPage;
            this.loading= false;

            res.data.list.forEach((item) => {
              this.list.push(item);
            })

          }
        })
    },
    // 加载
    load() {
      console.log("loading");
      this.loading= true;
      this.list_json.pageNum = this.list_json.pageNum + 1;
      this.get_list(this.list_json);
    },
    link_makeDeta(e) {
      this.$router.push({
        path: "/MakeDeta",
        query: {
          id: e
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
    @import "../../../style/My/Order/OrderList";
    .list_ul{
      height: 100%;
    }
    .list_ul_li{
      padding: 0.75rem 1.375rem 1.375rem 1.375rem!important;
    }
</style>
